export const SET_INSTALL_MOBILE_APP_DIALOG_OPEN =
  'SET_INSTALL_MOBILE_APP_DIALOG_OPEN';
export const SHOW_STEP1_INVITE_INPUT = 'SHOW_STEP1_INVITE_INPUT';
export const EMAIL_INVITE_SENDING = 'EMAIL_INVITE_SENDING';
export const EMAIL_INVITE_SENT = 'EMAIL_INVITE_SENT';

export const setInstallMobileAppDialogOpen = isOpen => ({
  type: SET_INSTALL_MOBILE_APP_DIALOG_OPEN,
  payload: isOpen,
});

export const showStep1InviteInput = () => ({
  type: SHOW_STEP1_INVITE_INPUT,
});

export const sendEmailInvite = () => ({
  type: EMAIL_INVITE_SENDING,
});

export const emailInviteSent = () => ({
  type: EMAIL_INVITE_SENT,
});

export const SET_INSTALL_CHAT_APP_DIALOG_OPEN =
  'SET_INSTALL_CHAT_APP_DIALOG_OPEN';

export const setInstallChatAppDialogOpen = isOpen => ({
  type: SET_INSTALL_CHAT_APP_DIALOG_OPEN,
  payload: isOpen,
});
